import { render, staticRenderFns } from "./SettingDetails.vue?vue&type=template&id=4a9fa262&scoped=true"
import script from "./SettingDetails.vue?vue&type=script&lang=ts"
export * from "./SettingDetails.vue?vue&type=script&lang=ts"
import style0 from "./SettingDetails.vue?vue&type=style&index=0&id=4a9fa262&lang=scss"
import style1 from "./SettingDetails.vue?vue&type=style&index=1&id=4a9fa262&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9fa262",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a9fa262')) {
      api.createRecord('4a9fa262', component.options)
    } else {
      api.reload('4a9fa262', component.options)
    }
    module.hot.accept("./SettingDetails.vue?vue&type=template&id=4a9fa262&scoped=true", function () {
      api.rerender('4a9fa262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/components/SettingDetails.vue"
export default component.exports